module.exports = __webpack_public_path__ + "img/68240_egalsoft_600x334.63940681.jpg";